import BliList from '@blibli/blue.lists/dist/lists/blue/List'
import BliLists from '@blibli/blue.lists/dist/lists/blue/Lists'
import BliTooltip from '@blibli/blue.tooltip/dist/tooltip/blue/Tooltip'
import BliIconSiLogOut from '@blibli/blue-dls-library-icon/dist/LogOut'
import BliIconSiPeopleProfile from '@blibli/blue-dls-library-icon/dist/PeopleProfile'
import BliIconSiSetting from '@blibli/blue-dls-library-icon/dist/Setting'
import { mapState } from 'pinia'

import { api, pages } from '@/config'
import { useMemberStore } from '@/stores/member.js'
import { redirectTo } from '@/utils/browser.js'

export default {
  components: {
    BliList,
    BliLists,
    BliTooltip,
    BliIconSiPeopleProfile,
    BliIconSiSetting,
    BliIconSiLogOut
  },
  computed: {
    ...mapState(useMemberStore, ['profile']),
    name () {
      return this.profile?.data?.name || ''
    },
    firstname () {
      return this.profile?.data?.name.split(' ')[0]
    },
    company () {
      return this.profile?.data?.companyName || ''
    },
    performancePage () {
      return pages.performance.path
    }
  },
  methods: {
    doLogout () {
      redirectTo(api.auth.logout(window.location.origin))
    },
    redirectToSettingPage () {
      this.$router.push(pages.profile.path)
    }
  }
}
